/** 对账单单据号跳转：与审批待办 / 行追溯同一套 list 页 open 约定 */
const DOCS = {
  invoiceSales: { perm: 'finance:invoiceSales:info', load: () => import('./InvoiceSales.vue') },
  invoiceSalesRed: { perm: 'finance:invoiceSalesRed:info', load: () => import('./InvoiceSalesRed.vue') },
  invoicePurchase: { perm: 'finance:invoicePurchase:info', load: () => import('./InvoicePurchase.vue') },
  invoicePurchaseRed: { perm: 'finance:invoicePurchaseRed:info', load: () => import('./InvoicePurchaseRed.vue') },
  receivable: { perm: 'finance:receivable:info', load: () => import('./Receivable.vue') },
  payable: { perm: 'finance:payable:info', load: () => import('./Payable.vue') },
  salesReturnSettle: { perm: 'finance:salesReturnSettle:info', load: () => import('./SalesReturnSettle.vue') },
  purchaseReturnSettle: { perm: 'finance:purchaseReturnSettle:info', load: () => import('./PurchaseReturnSettle.vue') },
  receipt: { perm: 'finance:receipt:info', load: () => import('./Receipt.vue') },
  receiptRed: { perm: 'finance:receiptRed:info', load: () => import('./ReceiptRed.vue') },
  payment: { perm: 'finance:payment:info', load: () => import('./Payment.vue') },
  paymentRed: { perm: 'finance:paymentRed:info', load: () => import('./PaymentRed.vue') },
  advanceReceipt: { perm: 'finance:advanceReceipt:info', load: () => import('./AdvanceReceipt.vue') },
  advancePayment: { perm: 'finance:advancePayment:info', load: () => import('./AdvancePayment.vue') }
}

export default {
  data() {
    return { stmtPageComp: null }
  },
  methods: {
    canOpenStmtDoc(row) {
      if (!row || !row.billId || !row.billKind) return false
      const cfg = DOCS[row.billKind]
      return !!(cfg && this.isAuth(cfg.perm))
    },
    openStmtDoc(row) {
      const cfg = DOCS[row.billKind]
      if (!row.billId || !cfg) return
      if (!this.isAuth(cfg.perm)) {
        this.$message.warning('无查看该单据的权限')
        return
      }
      cfg.load().then(mod => {
        this.stmtPageComp = mod.default
        this.$nextTick(() => {
          const page = this.$refs.stmtPage
          if (!page) return
          if (typeof page.open === 'function') page.open(row.billId, true)
          else if (typeof page.addOrUpdateHandle === 'function') page.addOrUpdateHandle(row.billId, true)
        })
      }).catch(() => this.$message.error('打开单据详情失败'))
    }
  }
}
